import { createAction } from 'redux-act';
import { ITrack } from 'modules/reducers';

export const fetchTracks = createAction('Fetch Tracks');
export const fetchTracksSuccess = createAction<ITrack[]>('Fetch Tracks Success');
export const fetchTracksFailed = createAction('Fetch Tracks Failed');
